import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
const getSelected = basicSelector(state => state.selected);
const createSelectedSelector = key => createSelector(getSelected, selected => selected[key]);
export const getSelectedAddPanelTab = createSelectedSelector('addPanelTab');
export const getIsModulesTabSelected = createSelector([getSelectedAddPanelTab], tab => tab === 'modules');
export const getModulesSearchTerm = createSelector(getSelected, selected => {
  return (selected === null || selected === void 0 ? void 0 : selected.modulesSearchTerm) || '';
});
export const getBreakpointContext = createSelectedSelector('breakpointContext');
export const getCurrentSidebarTab = createSelectedSelector('currentTab');
export const getEditSidebarActiveTab = createSelectedSelector('editSidebarActiveTab');
export const getForcedHighlightedElementId = createSelectedSelector('forcedHighlightedElementId');
export const getHighlightedId = createSelectedSelector('highlightedElementId');
export const getIsInboxSectionHighlighted = createSelectedSelector('highlightInboxSection');
export const getSelectedFieldPath = createSelectedSelector('fieldPath');
export const getSelectedId = createSelectedSelector('selectedId');
export const getSelectedType = createSelectedSelector('selectedType');
export const getSidebarOpen = createSelectedSelector('sidebarOpen');
export const getShowErrorsImmediately = createSelectedSelector('showErrorsImmediately');
export const getIsElementOrSectionSelected = createSelector([getSelectedId], selectedId => selectedId !== undefined);